import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';

declare var H: any;

@Component({
  selector: 'app-here-map',
  templateUrl: './here-map.component.html',
  styleUrls: ['./here-map.component.scss']
})
export class HereMapComponent implements OnInit {

  @ViewChild("map") public mapElement: ElementRef;

  private _apikey = 'FxdW_WfZJWLVNpr3VaxnpkvVGA6mJAXmTHVsTOoqiio';

  @Input() public lat: any;

  @Input() public lng: any;

  @Input() public direction: any;

  @Input() public width: any;
  
  @Input() public height: any;

  @Output() changePosition = new EventEmitter<any>();

  private map: any;
  private marker: any;

  constructor() { }

  ngOnInit(): void {
    const svgMarkup = '<svg id="Layer_1" enable-background="new 0 0 512 512" height="32" viewBox="0 0 512 512" width="32"'
      + ' xmlns="http://www.w3.org/2000/svg"><g><path d="m144 461v23c0 11.05 8.95 20 20 20h184c11.05 0 20-8.95 20-20v-22.78z"'
      + ' fill="#ffd100"/><path d="m368 461.22v22.78c0 11.05-8.95 20-20 20h-40c11.05 0 20-8.95 20-20v-22.78z"'
      + ' fill="#cca700"/><path d="m396 216h-280c-11.046 0-20-8.954-20-20v-24c0-11.046 8.954-20 20-20h280c11.046 0 20 8.954 20 20v24c0 11.046-8.954 20-20 20z"'
      + ' fill="#ffd100"/><path d="m416 172v24c0 11.05-8.95 20-20 20h-40c11.05 0 20-8.95 20-20v-24c0-11.05-8.95-20-20-20h40c11.05 0 20 8.95 20 20z"'
      + ' fill="#cca700"/><path d="m357.842 464h-203.684c-10.299 0-18.915-7.822-19.907-18.074l-22.251-229.926h288l-22.251 229.926c-.992 10.252-9.607 18.074-19.907 18.074z"'
      + ' fill="#ffd100"/><path d="m400 216-22.25 229.93c-.99 10.25-9.61 18.07-19.91 18.07h-40c10.3 0 18.92-7.82 19.91-18.07l22.25-229.93z"'
      + ' fill="#cca700"/><path d="m392 152h-272v-8c0-75.111 60.889-136 136-136 74.902 0 136 60.682 136 136z"'
      + ' fill="#ffd100"/><path d="m392 144v8h-40v-8c0-68.131-50.165-124.829-116-134.54 82.234-12.108 156 51.454 156 134.54z"'
      + ' fill="#cca700"/><path d="m338.84 36.12-8.39 58.71c-1.4 9.85-9.84 17.17-19.8 17.17h-109.3c-9.96 0-18.4-7.32-19.8-17.17l-8.39-58.71c48.83-37.528 116.885-37.5 165.68 0z"'
      + ' fill="#595965"/><path d="m338.84 36.12-8.39 58.71c-1.4 9.85-9.84 17.17-19.8 17.17h-34.84c9.96 0 18.4-7.32 19.8-17.17l8.39-58.71c-18.6-14.29-40.99-23.89-65.42-27.02 35.902-4.528 71.635 5.021 100.26 27.02z"'
      + ' fill="#44454e"/><path d="m400 144.29v-.29c0-79.402-64.598-144-144-144s-144 64.598-144 144v.29c-13.551 1.947-24 13.629-24 27.71v24c0 11.34 6.78 21.12 16.497 25.518l21.792 225.179c.729 7.538 4.353 14.104 9.712 18.658v18.645c0 15.439 12.561 28 28 28h184c15.439 0 28-12.561 28-28v-18.645c5.359-4.555 8.982-11.12 9.712-18.658l21.792-225.179c9.715-4.398 16.495-14.178 16.495-25.518v-24c0-14.081-10.449-25.762-24-27.71zm-69.765-104.507-7.702 53.914c-.839 5.874-5.946 10.303-11.879 10.303h-109.308c-5.933 0-11.04-4.429-11.879-10.303l-7.702-53.914c20.951-14.967 46.582-23.783 74.235-23.783s53.284 8.816 74.235 23.783zm-162.917 12.007 6.31 44.17c1.958 13.705 13.874 24.04 27.718 24.04h109.309c13.844 0 25.76-10.335 27.718-24.04l6.31-44.17c24.22 23.303 39.317 56.025 39.317 92.21h-256c0-36.185 15.097-68.907 39.318-92.21zm192.682 432.21c0 6.617-5.383 12-12 12h-184c-6.617 0-12-5.383-12-12v-12.088c.713.054 1.431.088 2.158.088h203.685c.727 0 1.445-.035 2.158-.088v12.088zm9.786-38.844c-.598 6.182-5.733 10.844-11.944 10.844h-203.684c-6.211 0-11.346-4.662-11.944-10.844l-21.402-221.156h270.377zm38.214-249.156c0 6.617-5.383 12-12 12h-280c-6.617 0-12-5.383-12-12v-24c0-6.617 5.383-12 12-12h4 272 4c6.617 0 12 5.383 12 12z"/><path d="m218.357 335.043c3.89 2.095 8.741.64 10.836-3.25l22.23-41.279c.835-1.551 2.447-2.514 4.207-2.514h.74c1.76 0 3.372.963 4.207 2.513l22.23 41.28c1.445 2.684 4.202 4.208 7.05 4.208 1.281 0 2.58-.308 3.786-.958 3.89-2.095 5.346-6.946 3.25-10.836l-22.23-41.28c-3.63-6.74-10.64-10.927-18.293-10.927h-.74c-7.653 0-14.663 4.187-18.293 10.927l-22.23 41.28c-2.096 3.89-.64 8.742 3.25 10.836z"/><path d="m204.78 408h35.22c4.418 0 8-3.582 8-8s-3.582-8-8-8h-35.22c-2.636 0-4.78-2.144-4.78-4.78 0-.789.197-1.569.574-2.268l11.39-21.16c2.094-3.891.638-8.742-3.252-10.836-3.89-2.092-8.742-.638-10.836 3.252l-11.385 21.15c-1.629 3.017-2.491 6.427-2.491 9.862 0 11.458 9.322 20.78 20.78 20.78z"/><path d="m311.431 384.962c.372.689.569 1.47.569 2.258 0 2.636-2.144 4.78-4.78 4.78h-35.22c-4.418 0-8 3.582-8 8s3.582 8 8 8h35.22c11.458 0 20.78-9.322 20.78-20.78 0-3.435-.861-6.845-2.485-9.852l-11.39-21.16c-2.095-3.89-6.946-5.345-10.836-3.252-3.89 2.094-5.347 6.946-3.252 10.836z"/></g></svg>';
    const icon = new H.map.Icon(svgMarkup);
    const coords = {lat:0, lng: 0};
    this.marker = new H.map.Marker(coords, {icon: icon});
    this.marker.draggable = true;
  }

  public ngAfterViewInit() {
    let platform = new H.service.Platform({
        "apikey": this._apikey
    });
    let defaultLayers = platform.createDefaultLayers();
    this.map = new H.Map(
        this.mapElement.nativeElement,
        defaultLayers.vector.normal.map,
        {
            zoom: 18,
            center: { lat: this.lat, lng: this.lng }
        }
    );
    this.map.addObject(this.marker);
    window.addEventListener('resize', () => this.map.getViewPort().resize());
    const behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(this.map));
    const ui = H.ui.UI.createDefault(this.map, defaultLayers);
    window.addEventListener('resize', () => this.map.getViewPort().resize());
    this.map.addEventListener('dragstart', (ev) => {
      const target = ev.target;
      const pointer = ev.currentPointer;
      if (target instanceof H.map.Marker) {
        var targetPosition = this.map.geoToScreen(target.getGeometry());
        target['offset'] = new H.math.Point(pointer.viewportX - targetPosition.x, pointer.viewportY - targetPosition.y);
        behavior.disable();
      }
    }, false);

    this.map.addEventListener('dragend', (ev) => {
      const target = ev.target;
      if (target instanceof H.map.Marker) {
        this.changePosition.emit(target.getGeometry());
        behavior.enable();
      }
    }, false);

    this.map.addEventListener('drag', (ev) => {
      const target = ev.target;
      const pointer = ev.currentPointer;
      if (target instanceof H.map.Marker) {
        target.setGeometry(this.map.screenToGeo(pointer.viewportX - target['offset'].x, pointer.viewportY - target['offset'].y));
      }
    }, false);
  }

  findAndUpdateDirection(search) {
    if (search.length === 0)
      return;
    let platform = new H.service.Platform({
      "apikey": this._apikey
    });
    let geocoder = platform.getSearchService();
    let geocodingParameters = {
      q: search
    };
    geocoder.geocode(geocodingParameters,
      (result) => {
        if (result?.items.length)
        {
          const pos = result.items[0];
          this.changePosition.emit({lat: pos.position.lat, lng: pos.position.lng});
        }
      },
      (error) => {console.log(error)}
      );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.map && (changes.hasOwnProperty('lng') || changes.hasOwnProperty('lat'))) {
      const pos = {
        lat: changes.hasOwnProperty('lat') ? changes['lat'].currentValue : this.lat,
        lng: changes.hasOwnProperty('lng') ? changes['lng'].currentValue : this.lng
      }
      this.map.setCenter(pos);
      this.marker.setGeometry(pos);
    } else if (this.map && changes.hasOwnProperty('direction')) {
      this.findAndUpdateDirection(changes['direction'].currentValue);
    }
  }

  dragStart(ev: any) {
    
  }
}
